/*
This file is located in the main branch
Last time the file was updated (UTC): [06.12.2023 15:23:23]
Permissions to update outside the main branch: [false]
*/

export const map = async <I, O>(item: I | Promise<I>, mapper: (data: I) => O) => {
    if (item instanceof Promise) {
        return mapper(await item);
    } else {
        return mapper(item);
    }
};
